import {
  Box,
  Grid,
  TextField,
  createTheme,
  ThemeProvider,
  Menu,
  Stack,
  Select,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";

import MenuItem from "@mui/material/MenuItem";
import MUIDataTable from "mui-datatables";
import AddIcon from "@mui/icons-material/Add";

import MoreHorizTwoToneIcon from "@mui/icons-material/MoreHorizTwoTone";

import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import CheckIcon from "@mui/icons-material/Check";
import { LocalizationProvider } from "@mui/x-date-pickers";
import DatePicker from "../../../../Components/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import ClearIcon from "@mui/icons-material/Clear";
import { useNavigate } from "react-router-dom";

import HeaderLeave from "./HeaderLeave";
import StatusAlert from "../../../../StatusAlertList/StatusAlert";
import { useSelector } from "react-redux";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function LeaveEmployee() {
  const userPermissions = useSelector((state) => state?.user?.permissions);
  const [member, setMember] = React.useState("");
  const [leaveType, setLeaveType] = React.useState("");
  const navigate = useNavigate();
  const [duration, setDuration] = React.useState("");
  const [date, setDate] = useState(null); // Initialize state for the date
  const [memberError, setMemberError] = React.useState(false);
  const [reason, setReason] = useState("");
  const [fileName, setFileName] = useState("");
  const [open, setOpen] = React.useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  const Andrew = "Andrew";
  const Bohr = "Bohr";
  const Ceaser = "Ceaser";
  const Casual = "Casual";
  const Sick = "Sick";
  const Earned = "Earned";
  const Approved = "Approved";
  const Pending = "Pending";

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFileName(file.name); // Update file name
  };

  const handleDateChange = (newDate) => {
    setDate(newDate); // Update the date state
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleSave = () => {
    const list = { member, leaveType, status, duration, date };

    if (member === "") {
      setMemberError(true);
    } else {
      const list = { member, leaveType, status };

      setMemberError(false); // Reset the error state
      handleClose(); // Close the dialog
    }
  };

  const [update, setUpdate] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState({
    keys: [],
    values: [],
    open: false,
  });

  const handleClickUpdate = () => {
    setUpdate(true);
  };

  const handleUpdateClose = () => {
    setUpdate(false);
  };
  const handleOpenMenu = (id) => {
    setOpenMenuId(id);
  };
  const handleViewMore = () => {
    if (!Array.isArray(leaveFile) || leaveFile.length === 0) {
      showAlert("No data available to view", "warning");
      return;
    }

    const rowData = leaveFile.filter((row) => row && row.id === openMenuId);
    if (rowData.length > 0) {
      navigate(`/hr/leaves/${openMenuId}`, { state: rowData[0] });
    } else {
      showAlert("Selected item not found", "warning");
    }
  };

  const [status, setStatus] = useState("");

  const [updateMember, setUpdateMember] = React.useState("");
  const [updateLeaveType, setUpdateLeaveType] = React.useState("");

  const [updateDuration, setUpdateDuration] = React.useState("");
  const [updateDate, setUpdateDate] = useState(null); // Initialize state for the date
  const [updateMemberError, setUpdateMemberError] = React.useState(false);
  const [updateReason, setUpdateReason] = useState("");
  const [updateFileName, setUpdateFileName] = useState("");
  const [updateStatus, setUpdateStatus] = useState("");
  const [data, SetData] = useState([]);

  const [openMenuId, setOpenMenuId] = useState(null);

  const item = {
    member,
    memberError,
    reason,
    duration,
    date,
    leaveType,
    fileName,
  };

  async function SaveDate() {
    let result = await fetch(
      "https://rptpl.roadpilot.co.in/public/api/addBusinesslocation",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(item),
      }
    );

    result = await result.json();

    showAlert("Leave Added successfully", "success");

    getData();
    setOpen(false);
  }

  // Fix 1: Initialize leaveFile as an empty array
  const [leaveFile, setLeaveFile] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    try {
      let results = await fetch(
        "https://rptpl.roadpilot.co.in/public/api/listBusinessLocations"
      );

      const response = await results.json();

      // Fix 2: Ensure response is an array or default to empty array
      if (Array.isArray(response)) {
        setLeaveFile(response);
      } else {
        console.warn("API response is not an array:", response);
        setLeaveFile([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setLeaveFile([]); // Set to empty array if the fetch fails
      showAlert("Failed to load leave data", "error");
    }
  }
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openDropMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const columns = [
    {
      name: "name",
      label: "Employee",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Employee
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <td
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </td>
          );
        },
      },
    },
    {
      name: "",
      label: "Leave Date",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Leave Date
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <td
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </td>
          );
        },
      },
    },
    {
      name: "",
      label: "Duration",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Duration
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <td
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </td>
          );
        },
      },
    },
    {
      name: "",
      label: "Leave status",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Leave status
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <td
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </td>
          );
        },
      },
    },
    {
      name: "",
      label: "Leave Type",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Leave Type
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <td
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </td>
          );
        },
      },
    },
    {
      name: "",
      label: "Paid",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Paid
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <td
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </td>
          );
        },
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "right",
                paddingRight: "35px",
                borderBottom: "1px solid #ddd",
              }}
            >
              Action
            </th>
          );
        },
        customBodyRender: (value, tableMeta) => (
          <>
            <td
              key={value}
              style={{
                display: "flex",
                justifyContent: "flex-end", // Aligns content to the left
                alignItems: "center",
              }}
            >
              <div style={{ paddingRight: "5px" }}>
                <Button
                  id="basic-button"
                  aria-controls={openDropMenu ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openDropMenu ? "true" : undefined}
                  onClick={handleClick}
                >
                  <div onClick={() => handleOpenMenu(value)}>
                    <MoreHorizTwoToneIcon />
                  </div>
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={openDropMenu}
                  onClose={handleCloseMenu}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  {/* {userPermissions?.employees_leaves_add !== 0 && ( */}
                  <MenuItem onClick={handleCloseMenu}>
                    <div
                      onClick={() => handleViewMore(tableMeta.rowData)}
                      style={{
                        display: "flex",
                        justifyContent: "space-center",
                        alignItems: "center",
                      }}
                    >
                      <RemoveRedEyeIcon /> View More
                    </div>
                  </MenuItem>
                  <MenuItem onClick={handleCloseMenu}>
                    <div
                      onClick={() => {}}
                      style={{
                        display: "flex",
                        justifyContent: "space-center",
                        alignItems: "center",
                      }}
                    >
                      <CheckIcon /> Approve
                    </div>
                  </MenuItem>
                  <MenuItem onClick={handleCloseMenu}>
                    <div
                      onClick={() => {}}
                      style={{
                        display: "flex",
                        justifyContent: "space-center",
                        alignItems: "center",
                      }}
                    >
                      <ClearIcon /> Reject
                    </div>
                  </MenuItem>
                  {userPermissions?.employees_leaves_update !== 0 && (
                    <MenuItem onClick={handleCloseMenu}>
                      <div
                        onClick={() => handleEdit(value)}
                        style={{
                          display: "flex",
                          justifyContent: "space-center",
                          alignItems: "center",
                        }}
                      >
                        <EditNoteIcon /> Edit
                      </div>
                    </MenuItem>
                  )}
                  {userPermissions?.employees_leaves_delete !== 0 && (
                    <MenuItem onClick={handleCloseMenu}>
                      <div
                        onClick={() => handleDelete(value)}
                        style={{
                          display: "flex",
                          justifyContent: "space-center",
                          alignItems: "center",
                        }}
                      >
                        <DeleteForeverIcon /> Delete
                      </div>
                    </MenuItem>
                  )}
                </Menu>
              </div>
            </td>
          </>
        ),
      },
    },
  ];

  async function handleEdit(id) {
    let result = await fetch(
      " https://rptpl.roadpilot.co.in/public/api/businesslocationget/" + id
    );
    result = await result.json();

    SetData(result);
    handleClickUpdate();
  }

  useEffect(() => {
    setUpdateMember(data.member);
  }, [data.member]);

  useEffect(() => {
    setUpdateDate(data.date);
  }, [data.date]);

  useEffect(() => {
    setUpdateDuration(data.duration);
  }, [data.duration]);

  useEffect(() => {
    setUpdateMemberError(data.managerError);
  }, [data.managerError]);

  useEffect(() => {
    setUpdateFileName(data.fileName);
  }, [data.fileName]);

  useEffect(() => {
    setUpdateReason(data.reason);
  }, [data.reason]);

  useEffect(() => {
    setUpdateLeaveType(data.leaveType);
  }, [data.leaveType]);

  useEffect(() => {
    setUpdateStatus(data.status);
  }, [data.status]);

  async function UpdateData() {
    const formData = new FormData();

    formData.append("member", updateMember);
    formData.append("memberError", updateMemberError);
    formData.append("fileName", updateFileName);
    formData.append("date", updateDate);
    formData.append("reason", updateReason);
    formData.append("duration", updateDuration);
    formData.append("leaveType", updateLeaveType);
    formData.append("status", updateStatus);
    try {
      let response = await fetch(
        `https://rptpl.roadpilot.co.in/public/api/updateBusinessLocation/${data.id}`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update data");
      }

      showAlert("Leave updated successfully", "success");

      handleUpdateClose();
      getData(); // Assuming these functions are defined elsewhere in your code
    } catch (error) {
      console.error(error);
      showAlert("Failed to update business location", "error");
    }
  }

  async function handleDelete(id) {
    const response = await fetch(
      " https://rptpl.roadpilot.co.in/public/api/businesslocationdelete/" + id,
      {
        method: "DELETE",
      }
    );
    const result = await response.json(); // Assigning to a new variable

    getData();
    showAlert("Leave Deleted successfully", "warning");
  }

  // end delete

  const options = {
    selectableRows: "none",
    selectToolbarPlacement: "none",
    responsive: "standard",
    elevation: 0,
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 25, 100],
    tableBody: {
      style: {
        maxHeight: "500px",
        overflowY: "scroll",
        marginLeft: "5PX",
      },
    },
    tableHead: {
      style: {
        backgroundColor: "#f2f2f2",
        color: "black",
      },
    },
    rows: {
      style: {
        marginLeft: "5px",
        textAlign: "center",
      },
      selectableRowsOnClick: true,
    },
  };

  const getTheme = () =>
    createTheme({
      palette: {
        mode: "light",
        primary: {
          main: "#2196f3",
        },
        secondary: {
          main: "#03a9f4",
        },
      },
      typography: {
        fontFamily: ["Roboto", "Helvetica", "Arial", "Sans-serif"].join(","),
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              textTransform: "none",
            },
          },
        },
      },
      tableBody: {
        style: {
          maxHeight: "500px",
          overflowY: "scroll",
        },
      },
      tableHead: {
        style: {
          backgroundColor: "#f2f2f2",
          color: "black",
        },
      },
      rows: {
        style: {
          "&:hover": {
            backgroundColor: "#f2f2f2",
          },
        },
      },
    });

  // Table Ends Here
  const handleCancel = () => {};
  return (
    <>
      <StatusAlert
        open={alertOpen}
        setOpen={setAlertOpen}
        message={alertMessage}
        severity={alertSeverity}
      />
      <HeaderLeave />
      <Box>
        <Dialog
          fullWidth
          maxWidth="lg"
          open={update}
          onClose={handleUpdateClose}
          TransitionComponent={Transition}
          PaperProps={{
            style: {
              position: "absolute",
              background: "#141b2d",
              top: "0",
              backgroundColor: "white",
              maxHeight: "95%",
              margin: "auto",
              overflowX: "hidden",
              zIndex: 1200,
            },
          }}
        >
          <AppBar sx={{ position: "relative" }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleUpdateClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} component="div">
                Update Leaves
              </Typography>
            </Toolbar>
          </AppBar>

          <Box
            sx={{ padding: "30px", margin: "20px", backgroundColor: "white" }}
          >
            <Typography
              sx={{ ml: 2, flex: 1, color: "black", fontSize: "20px" }}
              component="div"
            >
              Assign Leave
            </Typography>
            <hr sx={{ color: "grey" }} />

            <Grid
              container
              spacing={2}
              sx={{ marginTop: "20px", padding: "20px" }}
            >
              <Stack direction="row" sx={{ width: "100%" }}>
                <Grid
                  item
                  xs={12}
                  md={4}
                  sm={4}
                  sx={{ paddingRight: { xs: 0, sm: 2 } }}
                >
                  <Stack direction="column">
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Choose Member <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Select
                      value={updateMember}
                      autoFocus
                      onChange={(e) => setUpdateMember(e.target.value)}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      sx={{
                        border: "1px solid black",
                        boxSizing: "border-box",
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black !important",
                          "&:hover fieldset": {
                            borderColor: "black !important",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black !important",
                          },
                        },
                        color: "black",
                      }}
                    >
                      <MenuItem disabled value="">
                        <em>---</em>
                      </MenuItem>
                      <MenuItem value={Andrew}>Andrew</MenuItem>
                      <MenuItem value={Bohr}>Bohr</MenuItem>
                      <MenuItem value={Ceaser}>Ceaser</MenuItem>
                    </Select>
                    {memberError && (
                      <Typography variant="caption" style={{ color: "red" }}>
                        Please select a member
                      </Typography>
                    )}
                  </Stack>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                  sm={4}
                  sx={{ paddingRight: { xs: 0, sm: 2 } }}
                >
                  <Stack direction="column">
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Leave Type<span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Select
                      value={updateLeaveType}
                      autoFocus
                      onChange={(e) => setUpdateLeaveType(e.target.value)}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      sx={{
                        border: "1px solid black",
                        boxSizing: "border-box",
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black !important",
                          "&:hover fieldset": {
                            borderColor: "black !important",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black !important",
                          },
                        },
                        color: "black",
                      }}
                    >
                      <MenuItem disabled value="">
                        <em>---</em>
                      </MenuItem>
                      <MenuItem value={Casual}>Casual</MenuItem>
                      <MenuItem value={Sick}>Sick</MenuItem>
                      <MenuItem value={Earned}>Earned</MenuItem>
                    </Select>
                  </Stack>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                  sm={4}
                  sx={{ paddingRight: { xs: 0, sm: 2 } }}
                >
                  <Stack direction="column">
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Status
                    </Typography>
                    <Select
                      value={updateStatus}
                      autoFocus
                      onChange={(e) => setUpdateStatus(e.target.value)}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      sx={{
                        border: "1px solid black",
                        boxSizing: "border-box",
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black !important",
                          "&:hover fieldset": {
                            borderColor: "black !important",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black !important",
                          },
                        },
                        color: "black",
                      }}
                    >
                      <MenuItem disabled value="">
                        <em>---</em>
                      </MenuItem>
                      <MenuItem value={Approved}>Approved</MenuItem>
                      <MenuItem value={Pending}>Pending</MenuItem>
                    </Select>
                  </Stack>
                </Grid>
              </Stack>
            </Grid>

            <Grid container sx={{ padding: "20px" }}>
              <Stack direction="row" spacing={2}>
                <Grid
                  item
                  xs={12}
                  md={4}
                  sm={4}
                  sx={{ paddingRight: { xs: 0, sm: 2 } }}
                >
                  <Stack direction="column">
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Select Duration
                    </Typography>
                    <FormControl>
                      <RadioGroup
                        onChange={(e) => setUpdateDuration(e.target.value)}
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                      >
                        <FormControlLabel
                          value="fullDay"
                          control={
                            <Radio
                              sx={{
                                color: "grey",
                                "&.Mui-checked": { color: "#430A5D" },
                              }}
                            />
                          }
                          label="full Day"
                          style={{ color: "black" }}
                        />
                        <FormControlLabel
                          value="multiple"
                          control={
                            <Radio
                              sx={{
                                color: "grey",
                                "&.Mui-checked": { color: "#430A5D" },
                              }}
                            />
                          }
                          label="Multiple"
                          style={{ color: "black" }}
                        />
                        <FormControlLabel
                          value="halfDay"
                          control={
                            <Radio
                              sx={{
                                color: "grey",
                                "&.Mui-checked": { color: "#430A5D" },
                              }}
                            />
                          }
                          label="Half Day"
                          style={{ color: "black" }}
                        />
                        <FormControlLabel
                          value="secondDay"
                          control={
                            <Radio
                              sx={{
                                color: "grey",
                                "&.Mui-checked": { color: "#430A5D" },
                              }}
                            />
                          }
                          label="Second Half"
                          style={{ color: "black" }}
                        />
                      </RadioGroup>
                    </FormControl>
                  </Stack>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                  sm={4}
                  sx={{ paddingRight: { xs: 0, sm: 2 } }}
                >
                  <Stack direction="column">
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Date
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer
                        components={["DatePicker"]}
                        onChange={(e) => handleDateChange(e.target.value)}
                        sx={{ marginTop: "-10px" }}
                      >
                        <DatePicker
                          value={updateDate}
                          onChange={handleDateChange}
                          sx={{
                            border: "1px solid black",
                            borderRadius: "5px",
                            "& .MuiOutlinedInput-root": {
                              borderColor: "black !important",
                              color: "black !important",
                              "&:hover fieldset": {
                                borderColor: "black !important",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "black !important",
                              },
                            },
                            "& .MuiSvgIcon-root": {
                              color: "black",
                            },
                          }}
                        >
                          {(params) => (
                            <TextField {...params} variant="outlined" />
                          )}
                        </DatePicker>
                      </DemoContainer>
                    </LocalizationProvider>
                  </Stack>
                </Grid>
              </Stack>
            </Grid>
            <Grid container sx={{ padding: "20px" }}>
              <Stack direction="column" sx={{ width: "100%" }}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Reason for Absence<span style={{ color: "red" }}>*</span>
                </Typography>
                <textarea
                  id="reason"
                  value={updateReason}
                  onChange={(e) => setUpdateReason(e.target.value)}
                  style={{
                    border: "1px solid black",
                    borderRadius: "4px",
                    padding: "10px",
                    width: "100%",
                    boxSizing: "border-box",
                    minHeight: "100px", // Set your desired minimum height
                  }}
                />
              </Stack>
            </Grid>
            <Grid container sx={{ padding: "20px" }}>
              <Stack direction="column" sx={{ width: "100%" }}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Add File<span style={{ color: "red" }}>*</span>
                </Typography>
                <label
                  htmlFor="file-upload"
                  style={{
                    cursor: "pointer",
                    color: "black",
                    border: "1px solid black",
                    borderRadius: "4px",
                    padding: "10px",
                    width: "100%",
                    boxSizing: "border-box",
                    minHeight: "100px", // Set your desired minimum height
                    backgroundColor: "lightgray", // Change background color to light gray
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  Upload File
                </label>
                <input
                  onChange={handleFileChange} // Call handleFileChange when file changes
                  type="file"
                  id="file-upload"
                  style={{ display: "none" }}
                />
                {fileName && <div style={{ color: "black" }}>{fileName}</div>}
              </Stack>
            </Grid>

            <Grid container sx={{ padding: "10px 10px 20px 10px" }}>
              <Grid item sx={11} className="messageFooter">
                <Box className="response" onClick={SaveDate}>
                  Update
                </Box>
                <Box className="cancel" onClick={handleCancel}>
                  Cancel
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Dialog>
      </Box>

      <List
        style={{
          background: "none",
          padding: 5,
        }}
      >
        <React.Fragment>
          {userPermissions?.employees_leaves_add !== 0 && (
            <Stack
              direction="row"
              spacing={2}
              sx={{ marginBottom: "5px", marginTop: "10px" }}
            >
              <Box
                onClick={handleClickOpen}
                sx={{
                  backgroundColor: "#1d82f5",
                  color: "#fff",
                  "&:hover": { backgroundColor: "orange" },
                  textAlign: "center",
                  padding: "10px",
                  marginLeft: "10px",
                  height: "40px",
                  width: "115px",
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                  borderRadius: "4px",
                  fontSize: "15px",
                  fontFamily: "sans-serif",
                  cursor: "pointer",
                }}
              >
                <AddIcon />
                Add Leave
              </Box>
            </Stack>
          )}
          <Dialog
            fullWidth
            maxWidth="lg"
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
            PaperProps={{
              style: {
                position: "absolute",
                background: "#141b2d",
                top: "0",
                backgroundColor: "white",
                maxHeight: "95%",
                margin: "auto",
                overflowX: "hidden",
                zIndex: 1200,
              },
            }}
          >
            <AppBar sx={{ position: "relative", bgcolor: "#1d82f5" }}>
              <Toolbar>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={handleClose}
                  aria-label="close"
                >
                  <CloseIcon fontSize="large" />
                </IconButton>
                <Typography
                  sx={{ ml: 2, flex: 1, fontSize: "20px" }}
                  component="div"
                >
                  New Leave
                </Typography>
              </Toolbar>
            </AppBar>
            <Box sx={{ backgroundColor: "white" }}>
              <Typography
                sx={{
                  flex: 1,
                  color: "black",
                  fontSize: "20px",
                  padding: "20px",
                  borderBottom: "1px solid gray",
                }}
                component="div"
              >
                Assign Leave
              </Typography>

              <Grid container spacing={2} sx={{ padding: "20px" }}>
                <Stack
                  direction={{ xs: "column", md: "row" }}
                  sx={{ width: "100%" }}
                >
                  <Grid
                    item
                    xs={11}
                    md={4}
                    sm={6}
                    sx={{ paddingLeft: { xs: 2 }, paddingTop: { xs: 2 } }}
                  >
                    <Stack direction="column">
                      <Typography
                        variant="p"
                        gutterBottom
                        style={{ color: "black" }}
                      >
                        Choose Member <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Select
                        value={member}
                        autoFocus
                        onChange={(e) => setMember(e.target.value)}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        sx={{
                          border: "1px solid black",
                          boxSizing: "border-box",
                          "& .MuiOutlinedInput-root": {
                            borderColor: "black !important",
                            "&:hover fieldset": {
                              borderColor: "black !important",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "black !important",
                            },
                          },
                          color: "black",
                        }}
                      >
                        <MenuItem disabled value="">
                          <em>---</em>
                        </MenuItem>
                        <MenuItem value={Andrew}>Andrew</MenuItem>
                        <MenuItem value={Bohr}>Bohr</MenuItem>
                        <MenuItem value={Ceaser}>Ceaser</MenuItem>
                      </Select>
                      {memberError && (
                        <Typography variant="caption" style={{ color: "red" }}>
                          Please select a member
                        </Typography>
                      )}
                    </Stack>
                  </Grid>
                  <Grid
                    item
                    xs={11}
                    md={4}
                    sm={6}
                    sx={{ paddingLeft: { xs: 2 }, paddingTop: { xs: 2 } }}
                  >
                    <Stack direction="column">
                      <Typography
                        variant="p"
                        gutterBottom
                        style={{ color: "black" }}
                      >
                        Leave Type<span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Select
                        value={leaveType}
                        autoFocus
                        onChange={(e) => setLeaveType(e.target.value)}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        sx={{
                          border: "1px solid black",
                          boxSizing: "border-box",
                          "& .MuiOutlinedInput-root": {
                            borderColor: "black !important",
                            "&:hover fieldset": {
                              borderColor: "black !important",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "black !important",
                            },
                          },
                          color: "black",
                        }}
                      >
                        <MenuItem disabled value="">
                          <em>---</em>
                        </MenuItem>
                        <MenuItem value={Casual}>Casual</MenuItem>
                        <MenuItem value={Sick}>Sick</MenuItem>
                        <MenuItem value={Earned}>Earned</MenuItem>
                      </Select>
                    </Stack>
                  </Grid>
                  <Grid
                    item
                    xs={11}
                    md={3}
                    sm={6}
                    sx={{ paddingLeft: { xs: 2 }, paddingTop: { xs: 2 } }}
                  >
                    <Stack direction="column">
                      <Typography
                        variant="p"
                        gutterBottom
                        style={{ color: "black" }}
                      >
                        Status
                      </Typography>
                      <Select
                        value={status}
                        autoFocus
                        onChange={(e) => setStatus(e.target.value)}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        sx={{
                          border: "1px solid black",
                          boxSizing: "border-box",
                          "& .MuiOutlinedInput-root": {
                            borderColor: "black !important",
                            "&:hover fieldset": {
                              borderColor: "black !important",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "black !important",
                            },
                          },
                          color: "black",
                        }}
                      >
                        <MenuItem disabled value="">
                          <em>---</em>
                        </MenuItem>
                        <MenuItem value={Approved}>Approved</MenuItem>
                        <MenuItem value={Pending}>Pending</MenuItem>
                      </Select>
                    </Stack>
                  </Grid>
                </Stack>
              </Grid>

              <Grid container sx={{ padding: "20px" }}>
                <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
                  <Grid
                    item
                    xs={11}
                    md={7}
                    sm={11}
                    sx={{ paddingRight: { xs: 0, sm: 2 } }}
                  >
                    <Stack direction="column">
                      <Typography
                        variant="p"
                        gutterBottom
                        style={{ color: "black" }}
                      >
                        Select Duration
                      </Typography>
                      <FormControl>
                        <RadioGroup
                          onChange={(e) => setDuration(e.target.value)}
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group"
                        >
                          <FormControlLabel
                            value="fullDay"
                            control={
                              <Radio
                                sx={{
                                  color: "grey",
                                  "&.Mui-checked": { color: "#1d82f5" },
                                }}
                              />
                            }
                            label="full Day"
                            style={{ color: "black" }}
                          />
                          <FormControlLabel
                            value="multiple"
                            control={
                              <Radio
                                sx={{
                                  color: "grey",
                                  "&.Mui-checked": { color: "#1d82f5" },
                                }}
                              />
                            }
                            label="Multiple"
                            style={{ color: "black" }}
                          />
                          <FormControlLabel
                            value="halfDay"
                            control={
                              <Radio
                                sx={{
                                  color: "grey",
                                  "&.Mui-checked": { color: "#1d82f5" },
                                }}
                              />
                            }
                            label="Half Day"
                            style={{ color: "black" }}
                          />
                          <FormControlLabel
                            value="secondDay"
                            control={
                              <Radio
                                sx={{
                                  color: "grey",
                                  "&.Mui-checked": { color: "#1d82f5" },
                                }}
                              />
                            }
                            label="Second Half"
                            style={{ color: "black" }}
                          />
                        </RadioGroup>
                      </FormControl>
                    </Stack>
                  </Grid>
                  <Grid
                    item
                    xs={11}
                    md={4}
                    sm={11}
                    sx={{ paddingRight: { xs: 0, sm: 2 } }}
                  >
                    <Stack direction="column">
                      <Typography
                        variant="p"
                        gutterBottom
                        style={{ color: "black" }}
                      >
                        Date
                      </Typography>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer
                          components={["DatePicker"]}
                          onChange={(e) => handleDateChange(e.target.value)}
                          sx={{ marginTop: "-10px" }}
                        >
                          <DatePicker
                            value={date}
                            onChange={handleDateChange}
                            sx={{
                              border: "1px solid black",
                              borderRadius: "5px",
                              "& .MuiOutlinedInput-root": {
                                borderColor: "black !important",
                                color: "black !important",
                                "&:hover fieldset": {
                                  borderColor: "black !important",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: "black !important",
                                },
                              },
                              "& .MuiSvgIcon-root": {
                                color: "black",
                              },
                            }}
                          >
                            {(params) => (
                              <TextField {...params} variant="outlined" />
                            )}
                          </DatePicker>
                        </DemoContainer>
                      </LocalizationProvider>
                    </Stack>
                  </Grid>
                </Stack>
              </Grid>
              <Grid container sx={{ padding: "20px" }}>
                <Stack direction="column" sx={{ width: "100%" }}>
                  <Typography
                    variant="p"
                    gutterBottom
                    style={{ color: "black" }}
                  >
                    Reason for Absence<span style={{ color: "red" }}>*</span>
                  </Typography>
                  <textarea
                    id="reason"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    style={{
                      border: "1px solid gray",
                      borderRadius: "4px",
                      padding: "10px",
                      width: "100%",
                      boxSizing: "border-box",
                      minHeight: "100px", // Set your desired minimum height
                    }}
                  />
                </Stack>
              </Grid>
              <Grid container sx={{ padding: "20px" }}>
                <Stack direction="column" sx={{ width: "100%" }}>
                  <Typography
                    variant="p"
                    gutterBottom
                    style={{ color: "black" }}
                  >
                    Add File<span style={{ color: "red" }}>*</span>
                  </Typography>
                  <label
                    htmlFor="file-upload"
                    style={{
                      cursor: "pointer",
                      color: "black",
                      border: "1px solid gray",
                      borderRadius: "4px",
                      padding: "10px",
                      width: "100%",
                      boxSizing: "border-box",
                      minHeight: "100px", // Set your desired minimum height
                      backgroundColor: "#fff", // Change background color to light gray
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    Upload File
                  </label>
                  <input
                    onChange={handleFileChange} // Call handleFileChange when file changes
                    type="file"
                    id="file-upload"
                    style={{ display: "none" }}
                  />
                  {fileName && <div style={{ color: "black" }}>{fileName}</div>}
                </Stack>
              </Grid>

              <Grid container sx={{ padding: "10px 10px 20px 10px" }}>
                <Grid item sx={11} className="messageFooter">
                  <Box className="response" onClick={SaveDate}>
                    Save
                  </Box>
                  <Box className="cancel" onClick={handleCancel}>
                    Cancel
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Dialog>
        </React.Fragment>

        <Divider />
        <ListItemText style={{ background: "white", margin: 0 }}>
          <ThemeProvider theme={getTheme()}>
            <Box
              sx={{
                maxWidth: "100%", // Ensure it doesn't exceed the parent container
              }}
            >
              <MUIDataTable
                title={
                  <span
                    style={{
                      fontWeight: 700,
                      fontSize: "1.5rem",
                      color: "#333",
                    }}
                  >
                    Leave Lists
                  </span>
                }
                data={Array.isArray(leaveFile) ? leaveFile : []} // Ensure data is always an array
                columns={columns}
                options={{
                  ...options,
                  // Fix 5: Add onRowsDelete handler to properly handle deletions
                  onRowsDelete: (rowsDeleted) => {
                    return false; // Prevent automatic deletion
                  },
                  // Fix 6: Safe empty state display
                  textLabels: {
                    body: {
                      noMatch: "No records found",
                      toolTip: "Sort",
                    },
                  },
                }}
              />
            </Box>
          </ThemeProvider>
        </ListItemText>
      </List>
    </>
  );
}

export default LeaveEmployee;
